
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.footer-contact {
    color:var(--neutral-white);
}

  .footer-contact p {
    margin-top:0.625rem;
    margin-bottom:0.625rem;
}

  .footer-contact a {
    overflow-wrap:break-word;
}

  .footer-contact a {
    color:var(--neutral-white);
}

  .footer-contact a {
    text-decoration-line:none;
}

  .footer-contact a:hover {
    text-decoration-line:underline;
}

:host([site='BH']) .footer-contact {
    font-size:var(--bh-fs-body-01);
    line-height:var(--bh-lh-body-01);
    letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) .footer-contact{
    text-wrap:wrap;
  }

:host([site='BH']) strong {
    font-family:var(--bh-ff-display);
}

:host([site='BH']) strong {
    font-size:var(--bh-fs-heading-04);
    line-height:var(--bh-lh-heading-04);
    letter-spacing:var(--bh-ls-heading-04);
}

:host([site='BH']) strong {
    font-weight:var(--fw-normal);
}
`;